import { useEffect } from 'preact/hooks'
import { useAthosContext } from 'libs/athos/fetchers/provider'
import { AthosBlogSearchProvider } from 'libs/athos/fetchers/blog'
import { globalState } from '@/components/helpers/utils'
import { QuickSearchSuggestions } from 'libs/athos/components/quick-search/QuickSearchSuggestions'

function BlogSuggestionContent({ query, fallbackTitle, fallbackSuggestions, fallbackQuery }) {
  const { refine, results, isLoading } = useAthosContext()

  useEffect(() => {
    if (query) refine('query', query)
  }, [query])

  const hasBlogResults = !isLoading && results?.results?.length > 0

  if (!hasBlogResults) {
    return (
      <>
        <h3 className="paragraph-b font-extended font-semibold">{fallbackTitle}</h3>
        <QuickSearchSuggestions query={fallbackQuery} defaultSuggestions={fallbackSuggestions} />
      </>
    )
  }

  return (
    <>
      <h3 className="paragraph-b font-extended font-semibold">Blog Posts</h3>
      <div className="flex w-full flex-grow flex-col gap-y-0.75">
        {results.results.map((blog) => (
          <a href={blog.url} className="group w-fit paragraph-s first-letter:capitalize link-fade" key={blog.id}>
            <span>{blog.title}</span>
          </a>
        ))}
      </div>
    </>
  )
}

export function QuickSearchBlogSuggestions({ query, fallbackTitle, fallbackSuggestions, fallbackQuery }) {
  const blogSiteId = globalState?.siteIds?.blogs

  if (!blogSiteId || !query) {
    return (
      <>
        <h3 className="paragraph-b font-extended font-semibold">{fallbackTitle}</h3>
        <QuickSearchSuggestions query={fallbackQuery} defaultSuggestions={fallbackSuggestions} />
      </>
    )
  }

  return (
    <AthosBlogSearchProvider category="blogs" runOnMount={false} resultsPerPage={4}>
      <BlogSuggestionContent
        query={query}
        fallbackTitle={fallbackTitle}
        fallbackSuggestions={fallbackSuggestions}
        fallbackQuery={fallbackQuery}
      />
    </AthosBlogSearchProvider>
  )
}
